import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from // Search,
"react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

import { Alert, Snackbar } from "@mui/material";


// import makeAnimated from "react-select/animated";

const DataTableSpecificities = ({ listSpecificities }) => {
  const [specificities, setSpecificities] = useState(listSpecificities);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);

  const columns = [
    {
      dataField: "name",
      text: "Libellé",
    },
    {
      dataField: "id",
      text: "Type",
      formatter: buttonDeleteFormatter,
    },
  ];


  function buttonDeleteFormatter(cell, row) {
    console.log("row", row);


    if(row.type===0){
      return (
        <span>Spécificité</span>)
    }else  if(row.type===1){
      return (
        <span>Spécificité de couleur</span>)
    }
   
  }
  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  function handleTableChange({ specificities }) {
    return specificities;
  }

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Spécificités</h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={specificities}
          columns={columns}
          onTableChange={handleTableChange}
        >
          {(props) => (
            <div>
              <div className="row">
                <BootstrapTable {...props.baseProps} striped hover condensed />
              </div>
            </div>
          )}
        </ToolkitProvider>

        {openInfoAlert && (
          <Snackbar
            open={openInfoAlert}
            autoHideDuration={2000}
            onClose={handleInfoClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          >
            <Alert variant="filled" onClose={handleInfoClose} severity="info">
              {infoAlertText}
            </Alert>
          </Snackbar>
        )}
      </div>
    </div>
  );
};
export default DataTableSpecificities;
